import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getBlogPost } from '../data/blogs';

const BlogPostPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPost(slug) : undefined;

  if (!post) {
    return (
      <div className="container mx-auto px-4 py-24 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Post not found</h1>
        <p className="text-lg text-gray-600 mb-8">
          The article you're looking for doesn't exist or may have been moved.
        </p>
        <Link to="/blog" className="text-accent-600 font-medium hover:text-accent-700">
          &larr; Back to Blog
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="bg-gradient-to-r from-primary-800 to-primary-700 text-white py-20 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500 opacity-20 rounded-full blur-2xl"></div>
        <div className="container mx-auto px-4 relative max-w-3xl">
          <p className="text-sm text-white/80 mb-4">
            {post.date} &middot; {post.author}
          </p>
          <h1 className="text-3xl md:text-4xl font-bold">{post.title}</h1>
        </div>
      </div>

      <article className="container mx-auto px-4 py-16 max-w-3xl">
        {post.content.split('\n\n').map((paragraph, index) => (
          <p key={index} className="text-lg text-gray-700 leading-relaxed mb-6">
            {paragraph}
          </p>
        ))}

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/blog" className="text-accent-600 font-medium hover:text-accent-700">
            &larr; Back to Blog
          </Link>
        </div>
      </article>
    </>
  );
};

export default BlogPostPage;
